import React, { useState, useEffect, createRef, useRef } from 'react'
import Arrow from '../../../../assets/images/arrow.png';
import ArrowLightBlue from '../../../../assets/images/Arrow_light_blue.png';
import { useTranslation } from 'react-i18next';
import Card from '../../../CustomComponents/Card';
import  { LineBreaksSpan } from '../../../../utils';
import { height } from "../../../CustomComponents/Card/CardStyles";
import BancorpPrivacyPolicy from '../BancorpPrivacyPolicy';
import UserAgreement from '../UserAgreement';
import DepositAgreement from '../DepositAgreement';
import SavingsAgreement from '../SavingsAgreement';
import ElectronicAgreement from '../ElectronicAgreement';
import Modal from '../../../CustomComponents/Modal';
import RegisterSuccessModal from '../RegisterSuccessModal';
import ElectronicModal from '../ElectronicModal';
import LineBreaks from '../../../../utils';
import { GetApiHeadersWithOutBearer, PostRequest } from '../../../../network/NetworkUtils';
import { useSelector, connect, useDispatch } from 'react-redux';
import app_env from '../../../../utils/app-config.json';
import { STATUS_SUCCESS_CODE, REGISTER_USER } from '../../../../network/URLConstants';
import { appTheme, retrieveData } from '../../../../helpers/utils/Utils';
import { displayErrorMessage } from '../../../../utils';
import { useKeyDown } from '../../../../hooks/useKeyDown';
import Loader from '../../../CustomComponents/Loader';
import CustomAlertModel from '../../../CustomComponents/CustomAlertModel';
import logFirebaseEvents from '../../../LogFirebaseEvents';
import { addLineBreaks } from '../../../../utils';
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle';

export const TermsandConditions = ({ finalRegistrationClick, openPersonalInfoSummaryClick, getDataFromPersonalInfo }) => {
const isFromSmiOne = useSelector((state) => state.fromSmiOne);
  const providerIdentifier = useSelector(state => state.providerIdentifier);
  const personalInfo = useSelector(state => state.signUpPersonelInfo);
  const issuerURL = useSelector(state => state.issuerURL);
  const emailFromProvider = useSelector(state => state.emailFromProvider);
  const button1Ref = useRef(null);
  const provider = useSelector(state => state.provider);
  const { t } = useTranslation();
  const [isElectronicVerifyModalOpen, setIsElectronicVerifyModalOpen] = useState(false);
  const [isRegisterSucessModalOpen, setRegisterSucessModalModalOpen] = useState(false);
  const [showPolicys, setShowPolicys] = useState('terms');
  const [checkedValues, setCheckedValues] = useState([]);
  const dispatch = useDispatch();
  const userId = useSelector(state => state.userId);
  const deviceId = useSelector(state => state.deviceId);
  const [errorMessage, setErrorMessage] = useState('');
  const SubTittleStylesModal = "font-serif-pro lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px] md:leading-[33px] sm:leading-[29px] leading-[31px] font-normal sm:text-[var(--text-clr-secondary)] text-[var(--text-clr-secondary3)]";
  const [isLoading, setIsLoading] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [largeImage, setLargeImage] = useState(false);
  const HighlightMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normaltext-[var(--modal-text-heading-clr)] cursor-pointer pointer-events-none";
  const HeaderMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal cursor-pointer pointer-events-none text-[var(--modal-text-heading-clr)]";
  const SubHeaderMsgStyles = "font-hanken-grotesk text-[var(--modal-text-heading-clr)] modal-title lg:text-[14px] md:text-[14px] sm:text-[15px] text-[17px] font-300 cursor-pointer pointer-events-none";
  const [highlightMsg, setHighlightMsg] = useState('')
  const [headerMsg, setheaderMsg] = useState('')
  const [subHeaderMsg, setSubHeaderMsg] = useState('')
  const [btn1Exists, setBtn1Exists] = useState(false)
  const [btn2Exists, setBtn2Exists] = useState(false)
  const [btn1Text, setBtn1Text] = useState(false)
  const [btn2Text, setBtn2Text] = useState('')
  const [modelImage, setModelImage] = useState('')
  const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
  const [footerMsg, setFooterMsg] = useState('');
  const [quickActions, setQuickActions] = useState(true)
  const SelectedCardDetails = useSelector(state => state.selectedCardDetails);
  const [isBorderNone, setisBorderNone] = useState(true);
  const [showErrorImg, setshowErrorImg] = useState(false);
  const [isEnroll, setIsEnroll] = useState(false)
  const isMobile = /Mobi|Android/i.test(navigator.userAgent);


  
  const [acceptAll, setAcceptAll] = useState(false);
  const signUpkudzuPlusTrue = useSelector(state => state.isSignUpKudzuplusTrue);
  const appThemeData = appTheme(signUpkudzuPlusTrue);
  const [checkboxesState, setCheckboxesState] = useState({
    privacy_user: false,
    deposit_savings: false,
    electronic_aggrement: false,
    savings_account_aggrement: false,
    penalty_perjury: false
  });

  const checkboxes = useSelector(state => state.signupTermsAndConditionCheckbox)

    useDocumentTitle(t('page_title_terms_conditions'));

  const trueCount = Object.values(checkboxes).reduce((acc, curr) => (curr === true ? acc + 1 : acc), 0);
  useEffect(() => {
  }, [trueCount, checkboxes])

  useEffect(() => {
    const allChecked = Object.values(checkboxes).every((value) => value);
    setAcceptAll(allChecked);
  }, [checkboxes]);

  const handleAcceptAllChange = (event) => {
    debugger;
    const isChecked = event.target.checked;
    setAcceptAll(isChecked);
  };

  useEffect(() => { if ((checkboxes.savings_account_aggrement && trueCount >= 4) || (!checkboxes.savings_account_aggrement && trueCount >= 3)) { console.log('checkboxes', checkboxes, 'truecount', trueCount); button1Ref.current.focus(); } }, [trueCount, checkboxes])


  const handleCheckboxChange = (event, checkboxKey) => {
    const isChecked = event.target.checked;
    dispatch({
      type: 'UPDATE_SIGN_UP_TERMS_CHECKBOX',
      payload: { 'key': checkboxKey, 'value': isChecked }
    })

  }

  const handleCheckboxKeyDown = (keyArray) => {
    let updatedKeyObj = {}
    keyArray.forEach((key) => {
      updatedKeyObj[key] = !checkboxesState[key]
      dispatch({
        type: 'UPDATE_SIGN_UP_TERMS_CHECKBOX',
        payload: { 'key': key, 'value': !checkboxesState[key] }
      })
    }
    )
    
    const updateObj = { ...checkboxesState, ...updatedKeyObj }
    setCheckboxesState(updateObj)

  }


  const handleClick = (type) => {
    setShowPolicys((prevState) => {
      if (type === 'privacy') {
        logFirebaseEvents("Terms_and_conditions", "bancorp’s_privacy_notice_clicked", "bancorp’s_privacy_notice_clicked", "", "");
        return 'privacy';
      } else if (type === 'agreement') {
        return 'agreement';
      } else if (type === 'deposit') {
        logFirebaseEvents("Terms_and_conditions", "deposit_account_agreement", "deposit_account_agreement", "", "");
        return 'deposit';
      } else if (type === 'savings') {
        return 'savings';
      } else if (type === 'electronic') {
        logFirebaseEvents("Terms_and_conditions", "electronic_communications_agreement_clicked", "electronic_communications_agreement_clicked", "", "");
        return 'electronic';
      } else {
        return 'terms';
      }
    });

  };




  const OnClickElectronicPapperless = (value) => {
    const updatedCheckboxes = { ...checkboxes, electronic_aggrement: value };
    dispatch({
      type: 'UPDATE_SIGN_UP_TERMS_CHECKBOX',
      payload: { 'key': 'electronic_aggrement', 'value': value }
    })



    const allChecked = Object.values(checkboxes).every((value) => value);
    setAcceptAll(allChecked);
    closeMobileVerificationModal();
  };


  const handleContinueClick = async () => {

    // Get the values of the checked checkboxes
    const checkedValues = Object.entries(checkboxes).map(([checkboxKey, checked]) => ({
      checkboxKey,
      checked,
    }));

    // Find the value of 'electronic_aggrement' checkbox

    const privacyAggrement = checkedValues.find(
      (checkbox) => checkbox.checkboxKey === 'privacy_user'
    );

    const depositAgreement = checkedValues.find(
      (checkbox) => checkbox.checkboxKey === 'deposit_savings'
    );

    const electronicAgreement = checkedValues.find(
      (checkbox) => checkbox.checkboxKey === 'electronic_aggrement'
    );

    const paperLessAgreement = checkedValues.find(
      (checkbox) => checkbox.checkboxKey === 'paperless_statement'
    );
    const savingsAccountAggrement = checkedValues.find(
      (checkbox) => checkbox.checkboxKey === 'savings_account_aggrement'
    );

    
    dispatch({ type: "SIGN_UP_TERMS_AND_CONDITIONS", payload: { signUpTermsAndConditions: checkboxes } });
    const deviceId = await retrieveData('updatedDeviceId');
    let headers = await GetApiHeadersWithOutBearer(deviceId);
    const requestObj = {
      "applicationId": personalInfo?.applicationId,
      "language": "en",
      "username": personalInfo?.username,
      "firstName": personalInfo?.firstName,
      "lastName": personalInfo?.lastName,
      "preferredName": personalInfo?.preferredName,
      "middleInitial": "",
      "ssn": personalInfo?.ssn,
      "dateOfBirth": personalInfo?.dateOfBirth,
      "line1": personalInfo?.line1,
      "line2": personalInfo?.line2,
      "city": personalInfo?.city,
      "state": personalInfo?.state,
      "zipCode": personalInfo?.zipCode,
      "isEsignAccepted": electronicAgreement.checked,
      "IsPrivacyPolicyAccepted": privacyAggrement.checked,
      "IsCHAgreementAccepted": true,
      "CreateSavings": checkboxes.savings_account_aggrement
    };
    if (personalInfo?.password !== undefined && personalInfo?.password !== '') {
      requestObj.password = personalInfo?.password;
    }

    if (providerIdentifier != null && providerIdentifier != undefined) {
      requestObj.provider = provider;
      requestObj.providerId = providerIdentifier;
      requestObj.issuerURL = issuerURL;
      requestObj.socialLoginEmail = emailFromProvider;
    }
    requestObj.formattedAddress = personalInfo?.formattedAddress;

    if (global.inviteCode != null && global.inviteCode != undefined) {
      requestObj.inviteCode = global.inviteCode
    }
    dispatch({ type: 'SIGN_UP_PERSONEL_INFO', payload: { signUpPersonelInfo: requestObj } });
    getDataFromPersonalInfo(requestObj);
    finalRegistrationClick()
    return;
  }

  useKeyDown(() => {
    const trueCount = Object.values(checkboxes).reduce((acc, curr) => (curr === true ? acc + 1 : acc), 0);
    if (!(button1Ref.current)) {
      if ((checkboxes.savings_account_aggrement && trueCount >= 4) || (!checkboxes.savings_account_aggrement && trueCount >= 3)) {
        if (!checkboxes.savings_account_aggrement) { showAlertModal(true, t(""), <span ><span className='text-[var(--greatExclamation-color)]' >{t('send_email_verify_code_great')}</span> {t("great_would_u_like_two_enroll")}</span>, t('ErnPercentageYield'), true, true, t('enroll_savings_account'), t('maybe_later'), true, require('../../../../assets/kudzu-plus-images/savingsTransferPlusbanner1.png'), false, true, false) }
        else {
          handleContinueClick();
        }
      }
    }
  }, ["Enter"]);




  const OpenElectricVerificationModal = () => {
    setIsElectronicVerifyModalOpen(true);

  };

  const closeMobileVerificationModal = () => {
    setIsElectronicVerifyModalOpen(false);
  };

  const openRegisterSuccessModalOpen = () => {
    setRegisterSucessModalModalOpen(true);

  };

  const closeRegisterSuccessModal = () => {
    setRegisterSucessModalModalOpen(false);
  };

  const onCancelBtnClick = () => {
    if (btn2Text == t('maybe_later')) {
      closeModel()
      handleContinueClick()
      logFirebaseEvents("Enroll_Savings_Account", "Maybe_later_Clicked", "Maybe_later_Clicked", "", "");
    }

  }


  const onAcptBtnClick = () => {
    if (btn1Text == t('enroll_savings_account')) {
      setIsEnroll(true); closeModel();
      logFirebaseEvents("Enroll_Savings_Account", "Enroll_Savings_Account_Clicked", "Enroll_Savings_Account_Clicked", "");
    }
  }

  useEffect(() => { }, [isEnroll])
  const closeModel = () => {
    setShowModel(false);
  }
  const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, showErrorImg, isBorderNone, largeImage) => {
    setshowErrorImg(showErrorImg)
    setisBorderNone(isBorderNone)
    setShowModel(showModel)
    setHighlightMsg(highlightMsg)
    setheaderMsg(headerMsg)
    setSubHeaderMsg(subHeaderMsg)
    setBtn1Exists(btn1Exists)
    setBtn2Exists(btn2Exists)
    setBtn1Text(btn1Text)
    setBtn2Text(btn2Text)
    setBtn1TypeAcpt(btn1TypeAcpt)
    setModelImage(modelImage)
    setLargeImage(largeImage)
  }



  return (

    <div className="sm:px-[6%] md:py-10 sm:py-12 flex flex-wrap sm:flex-nowrap scroll-mt-0">

      {/* {open ElectronicVerify verify modal} */}

      <Modal
        isOpen={isElectronicVerifyModalOpen}
        onClose={closeMobileVerificationModal}
        isLogo={false}
        Fullheight={true}
        title={null}
        subtitle={null}
        content={<div><ElectronicModal handleElectronicClick={OnClickElectronicPapperless} /></div>}
      />

      {/* {open Sucess verify modal} */}

      <Modal
        isOpen={isRegisterSucessModalOpen}
        onClose={closeRegisterSuccessModal}
        isLogo={false}
        subHeaderMsg={<p className="font-hanken-grotesk modal-title lg:text-[18px] 
        md:text-[17px] sm:text-[15px] text-[14px] font-normal cursor-pointer pointer-events-none">{t("standard_msg_and_data_rates_may_apply")}</p>}
        title={null}
        subtitle={null}
        content={<div><RegisterSuccessModal /></div>}
      />


      {showPolicys === 'terms' && (
        <Card
          footerBgDisabled={true}
          isWhiteForSignup={appThemeData.isWhiteBgForCard}
          isDarkForKudzu={appThemeData.isDarkBgForCard}
          heading={
            <>
              <span className='md:contents sm:flex font-serif-pro  text-[#2965FB] sm:text-[var(--signup-flow-heading-text)] lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px] md:leading-[33px] 
 sm:leading-[30px] leading-[31px] font-[400]'>{isEnroll ? t('great_exclamation') : t('almost_there')}</span>
            </>
          }


subheading={

  isEnroll

    ? isFromSmiOne

      ? addLineBreaks(t("review_savings"))

      : signUpkudzuPlusTrue

        ? t("terms_and_condition_heading5")

        : t("terms_and_conditions_savings_basic")

    : signUpkudzuPlusTrue

      ? t("terms_and_condition_spending_heading_onboard_plus")

      : t("terms_and_condition_spending_heading_onboard")

}

 
          Cardcaption={isEnroll ? LineBreaksSpan(t("terms_and_condition_saving_subheading")) : t('terms_and_conditions_card_heading')} header={true} footer={false}
          backgroundColor={'#EAEEEB'}
          cardHeight={'auto'} CardRadius={true}
          footerContent={
            <div className="flex justify-end 
            md:px-[5rem] sm:px-[4rem] px-[2.5rem] py-[4rem]">
              
            
              {((checkboxes.savings_account_aggrement && trueCount >= 4) || (!checkboxes.savings_account_aggrement && trueCount >= 3)) ? <div className="">

                <button
                  ref={button1Ref}
                  type="button"
                  className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
                text-[var(--transactions-filter-blue-text)] cursor-pointer flex items-center"
                  onKeyDown={(event) => {
                    if (event.key == 'Enter') {
                      event.preventDefault();
                      if (!(checkboxes.savings_account_aggrement)) {
                        setTimeout(() => {
                          showAlertModal(true, t(""), <span> <span className='text-[var(--greatExclamation-color)]' >{t('send_email_verify_code_great')}</span> {t("great_would_u_like_two_enroll")}</span>, t('ErnPercentageYield'), true, true, t('enroll_savings_account'), t('maybe_later'), true, require('../../../../assets/kudzu-plus-images/savingsTransferPlusbanner1.png'), false, true, false)
                        }, 500);
                      }
                      else {
                        handleContinueClick();
                      }
                    }
                  }}
                  onClick={() => {
                    if (!(checkboxes.savings_account_aggrement) && !isEnroll) {
                      showAlertModal(true, "",
                        <>
                          <span className='text-[var(--modal-text-highlight)]'>
                            {signUpkudzuPlusTrue ? t("send_email_verify_code_great") : ""}</span>
                          {" "}{t("great_would_u_like_two_enroll")}</>
                        , signUpkudzuPlusTrue ? "Earn 1.26% Annual Percentage Yield (APY) on your Kudzu+ savings account balance." : <p className='font-[600] text-[16px]'
                        >{addLineBreaks(t('set_aside_money_for_the_things_that_matter'))}</p>, true, true, t('enroll_savings_account'), t('maybe_later'), true,
                        signUpkudzuPlusTrue ? require('../../../../assets/kudzu-plus-images/enrollPlusIcon.png') : require('../../../../assets/images/illo_beneficiary_4x.png'),
                        false, true, signUpkudzuPlusTrue ? true : false);
                    }
                    else {
                      logFirebaseEvents("Terms_and_Conditions", "Terms_and_Conditions_Continue_Clicked", "Terms_and_Conditions_Continue_Clicked", "", "");
                      if (!checkboxes.savings_account_aggrement) {
                        return null;
                      }
                      else {
                        handleContinueClick();
                      }
                    }
                  }
                  } // Call handleContinue instead of openPhoneOTPModal directly
                >
                  {t('continue')}
                  <img
                    src={appThemeData.arrowWhiteTwofac}
                    className="w-3 h-3 md:w-[17px] sm:w-[11px] md:h-[17px] sm:h-[11px] w-[12px] h-[12px] ml-2"
                    alt="Arrow"
                  />
                </button>
              </div> : <div className="">
                <button
                  type="button"
                  className={`font-hanken-grotesk font-bold lg:text-[18px] md:text-[15px] sm:text-[14px] text-[16px]
                     text-[var(--twofac-modal-btn-clr-disabled)] 
                     cursor-pointer 
                 flex items-center  ${appThemeData ? 'opacity-75': ''}`}
                >
                  {t('continue')}
                  <img src={appThemeData.SignupNextArrow} className={`${signUpkudzuPlusTrue ? '' : 'w-3 h-3'} ml-2`}
                    alt="Arrow" />
                </button>
              </div>}
            </div>
          }
        >
          <p className='h-[43px] text-[var(--modal-text-heading-clr)] font-[500] md:text-[20px] sm:text-[12px] text-[16px] font-hanken-grotesk sm:mt-[10px] mt-[25px]'>{t('accept_terms_signup')}</p>
          <div className='mt-10 md:w-[460px] sm:w-[301px] w-full'>
            {!isEnroll &&
              <div className="flex mb-4" >
                <input
                  id="privacy-user-checkbox"
                  name="privacy-agreement"
                  type="checkbox"
                  className="checkbox-custom-organic checkbox-no-shadow checkbox-signup-terms"
                  value="privacy_user"
                  checked={checkboxes.privacy_user}
                  onKeyDown={(event) => {
                    console.log("event----", event)
                    if (event.key === 'Enter') {
                      event.preventDefault();
                      handleCheckboxKeyDown(['privacy_user', 'electronic_aggrement'])
                    }
                  }}
                  autoFocus
                  onChange={() => {
                    handleCheckboxKeyDown(['privacy_user', 'electronic_aggrement'])

                  }}
                  tabIndex="0"
                />
                <label htmlFor="privacy-user-checkbox" className="font-hanken-grotesk ml-4 sm:ml-2 md:ml-4 md:text-sm sm:text-[12px] 
              text-[14px] md:font-[540] sm:font-medium font-normal
            text-[var(--modal-text-heading-clr)]" >{t('read_and_agree')}
                  <span
                    tabIndex="0"
                    className=' ml-1 text-[var(--modal-text-highlight)] font-bold cursor-pointer'
                    onKeyDown={(event) => {
                      if (event.key === 'Enter') {
                        event.preventDefault();
                        handleClick('electronic')
                      }
                    }}
                    onClick={() => handleClick("electronic")}>{t('electronic_communications_agreement')}</span>{t('and')}
                  <span
                    className=' ml-1 text-[var(--modal-text-highlight)] cursor-pointer font-bold'
                    onKeyDown={(event) => {
                      if (event.key === 'Enter') {
                        event.preventDefault();
                        handleClick('privacy')
                      }
                    }}
                    tabIndex="0"
                    onClick={() => handleClick("privacy")}>{t('bancorp’s_privacy_notice')}</span>.
                  
                </label>
              </div>
            }

            {!isEnroll &&
              <div className="flex mb-4 mt-10">
                <input
                  id="deposit-savings-checkbox"
                  name="deposit-agreement"
                  type="checkbox"
                  className="checkbox-custom-organic checkbox-no-shadow checkbox-signup-terms"
                  onKeyDown={(event) => {
                    if (event.key === 'Enter') {

                      event.preventDefault();
                      handleCheckboxKeyDown(['deposit_savings'])
                    }
                  }}
                  value="deposit_savings"
                  checked={checkboxes.deposit_savings}
                  onChange={(event) =>
                    handleCheckboxKeyDown(['deposit_savings'])

                  }
                  tabIndex="0"
                />
               {/* need change for t and c       */}
              {/* plus dda agreements  signUpkudzuPlusTrue  is not */}
                <label htmlFor="deposit-savings-checkbox" className="font-hanken-grotesk ml-4 sm:ml-2 md:ml-4  md:text-sm sm:text-[12px] text-[14px] md:font-[540]
                sm:font-medium font-normal
             text-[var(--modal-text-heading-clr)] cu">
                  <span tabIndex="0" className=' ml-1 text-[var(--modal-text-highlight)] cursor-pointer font-bold'
                    onClick={() => handleClick("deposit")}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        event.preventDefault();
                        handleClick("deposit")
                      }
                    }}>{signUpkudzuPlusTrue ? (t("deposit_account_agreement_plus")):(t('deposit_account_agreement'))}</span>
                </label>
              </div>
            } 


            {isEnroll &&
              <div className="flex mb-4 mt-16">
                <input
                  id="savings-account-checkbox"
                  name="savings-agreement"
                  type="checkbox"
                  className="checkbox-custom-organic checkbox-no-shadow checkbox-signup-terms"
                  onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                      event.preventDefault();
                      handleCheckboxKeyDown(['savings_account_aggrement'])

                    }
                  }}
                  value="savings_account_aggrement"
                  checked={checkboxes.savings_account_aggrement}
                  onChange={(event) =>
                    handleCheckboxKeyDown(['savings_account_aggrement'])
                  }
                  tabIndex="0"
                  autoFocus
                />
                <label htmlFor="savings-account-checkbox" className="font-hanken-grotesk ml-4 sm:ml-2 md:ml-4 md:font-[540]  md:text-sm sm:text-[12px] text-[14px]
               sm:font-medium font-normal
             text-[var(--modal-text-heading-clr)] cu">
                  <span tabIndex="0" className=' ml-1 text-[var(--modal-text-highlight)] cursor-pointer font-bold'
                    onClick={() => {
                      handleClick("savings"); logFirebaseEvents("TermsConditions", "SavingsAccountAgreementClicked.", "SavingsAccountAgreementClicked", "");
                    }}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        event.preventDefault();
                        handleClick("savings")
                      }
                    }}>{signUpkudzuPlusTrue ? t('kudzu_savings_account_aggrement') : t('Savings_Account_Agreement') }</span>.
                </label>
              </div>
            }


            {errorMessage &&
              <div className={`mt-2 mb-2 `}>
                {displayErrorMessage(errorMessage)}
              </div>
            }
            <p className={`font-hanken-grotesk sm:font-[540] font-normal md:text-[16px] sm:text-[12px] text-[14px]
                 text-[var(--terms-text-clr)]
                 pb-[15rem] pt-12`}>
              {t('by_tapping_continue_i_am_confirming')} </p>
          </div>
        </Card>
      )
      }
      {
        showPolicys === 'privacy' && (
          <BancorpPrivacyPolicy handleClick={handleClick} />
        )
      }
      {
        showPolicys === 'agreement' && (
          <UserAgreement handleClick={handleClick} />
        )
      }
      {
        showPolicys === 'deposit' && (
          <DepositAgreement handleClick={handleClick} />
        )
      }
      {
        showPolicys === 'savings' && (
          <SavingsAgreement handleClick={handleClick} />
        )
      }
      {
        showPolicys === 'electronic' && (
          <ElectronicAgreement handleClick={handleClick} />
        )
      }
      <CustomAlertModel
        isOpen={showModel}
        onClose={closeModel}
        image={modelImage}
        highlightMsg={<p className={HighlightMsgStyles}>{highlightMsg}</p>}
        HeaderMsg={<p className={HeaderMsgStyles}>{headerMsg}</p>}
        subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
        btn1Exists={btn1Exists}
        btn2Exists={btn2Exists}
        btn1Text={btn1Text}
        btn2Text={btn2Text}
        btn1TypeAcpt={btn1TypeAcpt}
        // footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
        onAcptBtnClick={onAcptBtnClick}
        onCancelBtnClick={onCancelBtnClick}
        showErrorImg={showErrorImg}
        isBorderNone={isBorderNone}
        imageMargin={subHeaderMsg == t('send_email_verify_code_great') ? true : false}
        largeImage={largeImage}
      />
      {isLoading && <Loader />}
    </div >

  )
}

export default TermsandConditions;